import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {CalendarIcon, ClockRewindIcon} from '@/components/ui/icon/Icon'
import {StyledHomeCard} from './style'
import {IconContainer} from '@/components/ui/icon-container/IconContainer'
import {HomeEventsSkeleton} from './HomeEventsSkeleton'
import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {routes} from '@/utilities/constants/routes'
import {generatePath} from 'react-router-dom'
import dayjs from 'dayjs'
import {formatDate, formatLocaleDate} from '@/dayjs'
import {useAuthStore} from '@/features/auth/store/store'
import {useGetHomePageData} from '../../query/useGetHomePageData'
import {eventTypeMapToLabel} from '@/features/agenda/utils'
import {useTranslation} from '@/translations/i18n'

export const HomeEventsCard = () => {
    const {t} = useTranslation()
    const user = useAuthStore(state => state.user)

    const {data, isLoading} = useGetHomePageData({fields: ['events']})

    const today = dayjs()
    const formattedDate = formatLocaleDate(today.toDate(), 'DD-MM-YYYY')

    const searchParams = new URLSearchParams({
        category: 'custom',
        subjectIds: user?.id ?? ''
    }).toString()

    return (
        <StyledHomeCard>
            <Flexbox direction="column" gap={6} fullWidth>
                <Flexbox align="center" gap={4}>
                    <IconContainer size="lg" variant="primary">
                        <CalendarIcon />
                    </IconContainer>
                    <Text size="textXl" weight={500} palette="neutral" shade="600">
                        Eventi in programma
                    </Text>
                </Flexbox>

                {isLoading ? (
                    <HomeEventsSkeleton />
                ) : (
                    <Flexbox direction="column" gap={1} fullWidth>
                        {data?.events?.length === 0 ? (
                            <Flexbox fullWidth gap={2} direction="column" align="center" justify="center">
                                <CalendarIcon size={18} />
                                <Text size="textSm" palette="neutral" shade="500">
                                    {t('homepage:no_events')}
                                </Text>
                            </Flexbox>
                        ) : (
                            data?.events?.map((event, index) => (
                                <Flexbox key={index} align="center" gap={2}>
                                    <Flexbox align="center" gap={2} style={{minWidth: '95px'}}>
                                        <ClockRewindIcon size={16} />
                                        <Text size="textLg" weight={500} palette="neutral" shade="900">
                                            {event.time
                                                ? formatLocaleDate(
                                                      `${formatDate(event.date, 'YYYY-MM-DD')} ${event.time}`,
                                                      'H:mm'
                                                  )
                                                : '-'}
                                        </Text>
                                        <Text size="textLg" weight={500} palette="neutral" shade="900">
                                            -
                                        </Text>
                                        <Text size="textLg" weight={500} palette="neutral" shade="900">
                                            {event.time
                                                ? formatLocaleDate(
                                                      dayjs(`${formatDate(event.date, 'YYYY-MM-DD')} ${event.time}`)
                                                          .add(event.duration ?? 0, 'minutes')
                                                          .toString(),
                                                      'H:mm'
                                                  )
                                                : '-'}
                                        </Text>
                                    </Flexbox>
                                    <Flexbox align="center" gap={3}>
                                        <Text size="textLg" weight={500} palette="neutral" shade="900">
                                            • {event.eventPatients?.[0]?.patient?.fullName}
                                        </Text>
                                        {event.eventConsultants?.[0]?.accessType?.accessType && (
                                            <Text size="textLg" palette="neutral" shade="600">
                                                {t(
                                                    eventTypeMapToLabel[
                                                        event.eventConsultants?.[0]?.accessType?.accessType
                                                    ]
                                                )}
                                            </Text>
                                        )}
                                    </Flexbox>
                                </Flexbox>
                            ))
                        )}
                    </Flexbox>
                )}
            </Flexbox>

            <ButtonLink
                variant="secondary"
                to={{
                    pathname: generatePath(routes.AGENDA.path, {
                        entity: 'users',
                        view: 'agenda',
                        date: formattedDate
                    }),
                    search: searchParams
                }}
            >
                Vedi tutto
            </ButtonLink>
        </StyledHomeCard>
    )
}
